<app-search-product></app-search-product>
<div class="container" style="min-height: 80vh;">
    <p>
        <a [routerLink]="getTranslatedRoute('/home')">{{ 'Menu.accueil' | translate }}</a>
        <span> > </span>
        <span *ngIf="selectedTemplate">
            <a [routerLink]="getTranslatedRoute('/'+selectedTemplate.page)"> {{ selectedTemplate.name | translate}}</a>
        </span>
    </p>

    <div *ngIf="listMode && selectedTemplate">
        <div class="my-4 ">
            <h1 class="row title my-4">{{selectedTemplate.title | translate | uppercase}}</h1>
            <div class="list">
                <div *ngFor="let dynContent of dynamicContentList" class="list-item">
                    <app-general-dynamic-content-item [element]="dynContent"></app-general-dynamic-content-item>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!listMode">
        <div class="row justify-content-between canvas">
            <div class="col-12 col-lg-{{others.length==0 ? 12 : 8}}">
                <div class="row lay" *ngFor="let lay of selectedContent?.layout">
                    <div class="content-bloc col-12 col-md-{{el.column}}" *ngFor="let el of lay">
                        <div class="content-bloc-element html-content" *ngIf="getType(el.contentRef) == 'TEXT'" id="{{el.contentRef}}"></div>
                        <div class="content-bloc-element iframe" *ngIf="getType(el.contentRef) == 'VIDEO'" id="{{el.contentRef}}"></div>
                        <div class="content-bloc-element document" *ngIf="getType(el.contentRef) == 'DOCUMENT'" id="{{getContent(el.contentRef)?.id}}"></div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-3" *ngIf="others.length>0">
                <div class="others-bloc">
                    <h3 class="others-title">{{selectedTemplate.more|translate}}</h3>
                    <div *ngFor="let other of others" class="other" (click)="openOther(other.url)">
                        <h4 class="other-ref">{{other.reference}}</h4>
                        <div class="other-content">{{other.shortContent}}</div>
                    </div>
                    <div *ngIf="others.length==0" class="text-center mt-2">
                        <div>{{'DetailProduct.noResult' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="noContent" class="w-100 d-flex justify-content-between align-items-center">
        {{'DetailProduct.noResult' | translate}}
    </div>
</div>
